import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectTeacher {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectTeacher = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectTeacher) => {
  const itemList = useStoreState((state) => state.sms.staffList);
  const itemListFetch = useStoreActions((state) => state.sms.fetchStaffList);

  React.useEffect(() => {
    itemListFetch();
  }, []);

  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.staffId === id);
      onChange(value.staffId);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      className="staffName"
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Teacher"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.staffId} value={type.staffId}>
            {type.staffName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Teacher</Option>
      )}
    </Select>
  );
};
